import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { ToasterService } from 'common/src/modules/ui-components/toaster';
import { environment } from '../../../../environments/environment';
import { AppState } from '../../../store/state/app.state';
import { ResponseModel } from '../../../shared/models';
import { DisplayToaster } from '../../../shared/decorators/toaster';
import { SmptSettingsModel } from '../models';
import { selectCompanyProfile } from '../../../administration/store/selectors';
import { CompanyProfile } from '../../../administration/models/company-profile.model';
import { map } from 'rxjs/operators';


@Injectable()
export class AccountingSettingsSmtpService {
  private readonly apiEndpoint: string = `${environment.javaApiVersion}/accounting/settings/smtp-connection`;

  private wid: number;

  private apiUrl(url: string = ''): string {
    return `${this.apiEndpoint}/${this.wid}${url ? '/' : ''}${url}`;
  }

  constructor(
    private readonly toasterService: ToasterService,
    private readonly http: HttpClient,
    private readonly store: Store<AppState>,
  ) {
    this.store.select(selectCompanyProfile)
      .subscribe((profile: CompanyProfile) => {
        this.wid = profile.workspaceId;
      });
  }

  // public setSaveActionDisabled(response: ResponseModel<SmptSettingsModel>): void {
  //   if (
  //     response && response.data && (
  //       (response.data.runpleStatus === 'SENT' && response.data.emailServerType === SmtpEmailServerTypeEnum.RUNPLE)
  //      || (response.data.externalStatus === 'SENT' && response.data.emailServerType === SmtpEmailServerTypeEnum.EXTERNAL)
  //     )
  //   ) {
  //     this.store.dispatch(UpdateSaveActionDisabled({saveActionDisabled: false}));
  //   } else {
  //     this.store.dispatch(UpdateSaveActionDisabled({saveActionDisabled: true}));
  //   }
  // }

  @DisplayToaster({showErrorMessage: true})
  public getSmtpSettings(): Observable<ResponseModel<SmptSettingsModel>> {
    return this.http.get<ResponseModel<SmptSettingsModel>>(this.apiUrl())
      // .pipe(tap((response: ResponseModel<SmptSettingsModel>) => this.setSaveActionDisabled(response)));
  }

  @DisplayToaster({showErrorMessage: true})
  public updateSmtpSettings(connection: SmptSettingsModel): Observable<ResponseModel<SmptSettingsModel>> {
    return this.http.post<ResponseModel<SmptSettingsModel>>(this.apiUrl(), {...connection})
      // .pipe(tap((response: ResponseModel<SmptSettingsModel>) => this.setSaveActionDisabled(response)));
  }

  @DisplayToaster({showErrorMessage: true})
  public testSmtpConnection(emails: string[], connection: SmptSettingsModel): Observable<ResponseModel<SmptSettingsModel>> {
    return this.http.post<ResponseModel<SmptSettingsModel>>(this.apiUrl('test'), {emails, connection})
      // .pipe(tap((response: ResponseModel<SmptSettingsModel>) => this.setSaveActionDisabled(response)));
  }

  @DisplayToaster({showErrorMessage: true})
  public getSmtpMicrosoftAuthLink(runpleRedirectUri: string): Observable<string> {
    const params = { runpleRedirectUri };
    return this.http.get<ResponseModel<string>>(this.apiUrl('microsoft/auth-grant-url'), { params })
    .pipe(map((response: ResponseModel<string>) => response.data));
  }

  @DisplayToaster({showErrorMessage: true})
  public startSmtpMicrosoftAuth(): Observable<any> {
    return this.http.request<ResponseModel<any>>('post', this.apiUrl('microsoft/grant-processing'));
  }

  @DisplayToaster({showErrorMessage: true})
  public confirmSmtpMicrosoftAuth(code: string): Observable<any> {
    const params = { code };
    return this.http.get<ResponseModel<any>>(this.apiUrl('microsoft/token'), { params });
  }

  @DisplayToaster({showErrorMessage: true})
  public disableSmtpMicrosoftAuth(): Observable<any> {
    return this.http.delete<ResponseModel<any>>(this.apiUrl('microsoft'));
  }

  @DisplayToaster({showErrorMessage: true})
  public revokeSmtpMicrosoftAuth(): Observable<any> {
    return this.http.delete<ResponseModel<any>>(this.apiUrl('microsoft/revoke'));
  }


}
